import { useEffect, useState } from "react";
import { X } from "lucide-react";

export default function NotificationBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem("bannerDismissed");
    const isMobile = /Mobi|Android/i.test(navigator.userAgent);

    if (!dismissed && isMobile) {
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    setVisible(false);
    localStorage.setItem("bannerDismissed", "true");
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 bg-gradient-to-r from-blue-50 via-indigo-50 to-rose-50 border border-red-300 text-blue-900 px-4 py-3 rounded-xl shadow-lg ring-2 ring-red-300/60 flex items-center gap-3 z-50 max-w-sm mx-4">
      <span className="text-sm font-medium">
        💻 For the best experience, please use a laptop or desktop.
      </span>
      <button 
        onClick={dismiss} 
        className="ml-auto text-blue-600 hover:text-blue-800 hover:bg-blue-100 rounded-full p-1 transition-colors"
        aria-label="Dismiss notification"
      >
        <X size={16} />
      </button>
    </div>
  );
}
